<template>
  <cus-order-dialog>
    <template v-slot:title>
      <p v-if="is_detail" class="dialog-title">外部平台：查看訂單</p>
      <p v-else class="dialog-title">外部平台</p>
    </template>
    <template v-slot:body>
      <div class="body-wrap">
        <!--  訂單列表 -->
        <div v-if="!is_detail" class="order-list">
          <!-- 未接訂單bar -->
          <div class="type-unprocessed">
            <p>未接({{ getValidOutsideOrder?.length }})</p>
          </div>
          <order-list
            type="outside"
            :orderList="getValidOutsideOrder"
            v-model:selectOrder="selectOrder"
            v-model:listPage="listPage"
          ></order-list>
        </div>
        <!--  查看訂單 -->
        <div v-else class="order-detail">
          <all-detail-info :orderData="orderData"></all-detail-info>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="d-flex">
        <div v-if="!is_detail" class="d-flex" style="width: 50%">
          <cus-button text="關閉" color="white" :width="50" @click="close"></cus-button>
          <cus-button
            text="查看訂單"
            color="white"
            :width="50"
            :disabled="!selectOrder"
            @click="handleClickDetail"
          ></cus-button>
        </div>
        <cus-button v-else text="返回" color="white" :width="50" @click="backToList"></cus-button>
        <cus-button
          text="拒單"
          color="white"
          :width="25"
          :disabled="!canRejectOrder"
          @click="openHeaderDialog('rejectOutsideOrder')"
        ></cus-button>
        <cus-button
          text="接單"
          color="blue"
          :width="50"
          :disabled="!canAcceptOrder"
          @click="handleAcceptOrder"
        ></cus-button>
      </div>
    </template>
  </cus-order-dialog>
  <!-- 彈窗 -->
  <component :is="dialogTemplate"></component>
</template>
<script>
import { ref, inject, defineAsyncComponent, watch, computed } from 'vue';
import { useGetters, useActions } from '@/utils/mapStore';
import { useDialog } from '@/utils/dialog';
export default {
  name: 'outside-order',
  components: {
    OrderList: defineAsyncComponent(() => import('@/components/orderDialog/OrderList.vue')),
    AllDetailInfo: defineAsyncComponent(() => import('@/components/orderDialog/AllDetailInfo.vue')),
    RejectOrder: defineAsyncComponent(() => import('@/components/orderDialog/RejectOutsideOrder.vue')),
  },
  methods: {},
  setup() {
    //接受provide參數
    const close = inject('order_close');
    const controlCloseButton = inject('order_controlCloseButton');
    //設定列表參數
    const selectOrder = ref(null);
    const listPage = ref(1);
    const getPageItem = useGetters('handleOrder', ['getPageItem']);
    //取得訂單列表
    const getValidOutsideOrder = useGetters('handleOrder', ['getValidOutsideOrder']);

    //查看訂單
    const orderData = ref(null);
    const is_detail = ref(false);

    watch(is_detail, () => {
      controlCloseButton(is_detail.value);
    });
    const doGetOrderInfo = useActions('handleOrder', ['doGetOrderInfo']);
    const handleClickDetail = async () => {
      const res = await doGetOrderInfo(selectOrder.value.order_id);
      orderData.value = res;
      is_detail.value = true;
    };
    //返回列表
    const backToList = () => {
      is_detail.value = false;
      orderData.value = null;
    };

    //接單
    const doAcceptOrder = useActions('handleOrder', ['doAcceptOrder']);
    const handleAcceptOrder = async () => {
      await doAcceptOrder({ order_id: selectOrder.value.order_id, source: 'outside' });
      backToList();
      selectOrder.value = null;
      if (listPage.value > (Math.ceil(getValidOutsideOrder.value.length / getPageItem.value) || 1)) {
        listPage.value = Math.ceil(getValidOutsideOrder.value.length / getPageItem.value) || 1;
      }
    };

    const canRejectOrder = computed(() => {
      if (selectOrder.value == null) {
        return false;
      }
      //如果是UE跟熊貓 0元 則才能拒單
      if (selectOrder.value.source == 'uber_eat' || selectOrder.value.source == 'foodpanda') {
        if (selectOrder.value.total == 0) {
          return true;
        }
      }
      return false;
    });

    const canAcceptOrder = computed(() => {
      if (selectOrder.value == null) {
        return false;
      }
      //如果是UE跟熊貓 0元 則不能接單
      if (selectOrder.value.source == 'uber_eat' || selectOrder.value.source == 'foodpanda') {
        if (selectOrder.value.total == 0) {
          return false;
        }
      }
      return true;
    });

    //開啟彈窗
    const { dialogTemplate, openHeaderDialog, closeDialog } = useDialog();
    //拒單
    const doRejectOrder = useActions('handleOrder', ['doRejectOrder']);
    const handleRejectOrder = async (val) => {
      const data = {
        order_id: selectOrder.value.order_id,
        note: val.input_reason ? val.input_reason : val.select_reason,
        source: 'outside',
      };
      await doRejectOrder(data);
      closeDialog();
      backToList();
      selectOrder.value = null;
    };

    //未接訂單列表
    const doGetValidOutsideOrderList = useActions('handleOrder', ['doGetValidOutsideOrderList']);
    const getOutsideList = async function () {
      await doGetValidOutsideOrderList();
    };
    getOutsideList();

    return {
      close,
      selectOrder,
      listPage,
      getValidOutsideOrder,
      orderData,
      is_detail,
      handleClickDetail,
      backToList,
      handleAcceptOrder,
      openHeaderDialog,
      dialogTemplate,
      handleRejectOrder,
      canRejectOrder,
      canAcceptOrder,
    };
  },
};
</script>
<style lang="scss" scoped>
.dialog-title {
  text-align: center;
  font-size: 2.4rem;
  line-height: 60px;
  color: $color-blue;
}
$bar-height: 6vh;
.body-wrap {
  position: relative;
  padding: 0 4px;
}
.order-list {
  height: 100%;
  padding: 20px 0 0;
  display: grid;
  grid-template-rows: $bar-height auto;
  grid-gap: 8px;
  .type-unprocessed {
    width: 100%;
    background-color: $color-blue;
    border-radius: 27px;
    text-align: center;
    font-size: 2.2rem;
    color: #fff;
    line-height: $bar-height;
  }
}
.order-detail {
  width: 100%;
  height: 100%;
  background-color: #fff;
}
</style>
